import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from './Footer';
import StorageRequiredBanner from './StorageRequiredBanner';
import MigrationBanner from './MigrationBanner';
import CloudErrorHandler from './CloudErrorHandler';
import AppNavBar from './AppNavBar';
import { SketchPageShell } from './sketchy';
import { classNames } from '../utils/classNames';
import { useStorageGate } from '../hooks/useStorageGate';

const Layout: React.FC = () => {
  const location = useLocation();
  const { showBanner, showMigrationBanner } = useStorageGate();
  const isWelcome = location.pathname === '/welcome';
  const isTransferPage = location.pathname === '/settings/transfer';

  return (
    <SketchPageShell className="min-h-screen flex flex-col">
      <CloudErrorHandler />
      <AppNavBar showBackButton={!isWelcome} />
      {!isWelcome && (showMigrationBanner || showBanner) && (
        <div className="max-w-6xl mx-auto w-full px-4 sm:px-6 lg:px-8 pt-4 space-y-3">
          {showMigrationBanner && !isTransferPage && <MigrationBanner />}
          {showBanner && <StorageRequiredBanner />}
        </div>
      )}
      <main
        className={classNames(
          'relative flex-1 text-[var(--color-text)]',
          isWelcome ? 'py-2 px-4 sm:px-6 lg:px-8' : 'py-6 px-4 sm:px-6 lg:px-8'
        )}
      >
        <div className={isWelcome ? 'max-w-6xl mx-auto w-full' : 'max-w-6xl mx-auto'}>
          <Outlet />
        </div>
      </main>
      {!isWelcome && <Footer />}
    </SketchPageShell>
  );
};

export default Layout;
